(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.tabs.holdings-tab
  (:require
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [re-frame.core :as rf]
   [frontend.utils :as fu]
   [common.localization :as loc]
   [frontend.ui.component.badge.view :as badge]
   [common.util :as cu]
   [herb.core :as h]
   [frontend.ui.component.table.view :as table]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.event :as event]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.style :as style]
   [clojure.set :as set]
   [common.schema.entities.lp-portal.lp-report-holding :as lp-report-holding]))

(defn holding-reports-table
  [report holdings input-id]
  (let [contributor-options @(rf/subscribe [::editor-sub/holding-contributors])
        account-id @(rf/subscribe [::editor-sub/account-id])
        approver-options @(rf/subscribe [::editor-sub/holding-approvers])
        attachments @(rf/subscribe [::editor-sub/lp-report-attachments (:db/id report)])
        admin? @(rf/subscribe [::editor-sub/report-admin?])
        owner? (some #{account-id} (:lp-report/process-owners report))
        tr-props (table/tr-props {})
        th-props (table/th-props {})
        td-props (table/td-props {})]
    [:div
     {:class (h/<class common-style/table-wrapper)}
     [:table (table/table-props nil)
      [:thead
       [:tr tr-props
        [:th th-props "Holding"]
        [:th th-props "Text contributors"]
        [:th th-props "Text status"]
        [:th th-props "Approver"]
        [:th th-props "View"]
        [:th th-props "Data contributors"]
        [:th th-props "Data status"]
        [:th th-props "Data approvers"]
        [:th th-props "Data file"]]]
      [:tbody (table/tbody-props {})
       (->>
        report
        :lp-report/holdings
        (map (partial get holdings))
        (sort lp-report-holding/compare-holdings)
        (keep
         (fn [holding-report]
           (let [{:keys [db/id
                         lp-report-holding/name
                         lp-report-holding/text-contributors
                         lp-report-holding/data-contributors
                         lp-report-holding/template-type
                         lp-report-holding/text-approver
                         lp-report-holding/data-approver]}
                 holding-report
                 approve-access? (or @(rf/subscribe [::sub/can-approve-holding-data? id])
                                     @(rf/subscribe [::sub/can-approve-holding-report-text? id]))
                 holding-ctx {:fund-report     report
                              :admin?          admin?
                              :admin-or-owner? (or admin? owner?)
                              :holding-report  holding-report
                              :account-id      @(rf/subscribe [::editor-sub/account-id])}]
             (when
               (and (not= :lp-report-holding-template/no-reporting template-type)
                    (lp-report-holding/can-view? holding-ctx))
               ^{:key (str "holding-reports-body-row-" id)}
               [:tr tr-props
                [:td td-props name]
                [:td td-props
                 (->> text-contributors 
                      (map (fn [aid]
                             ^{:key (str "report-editor-" id "-contributor-" aid)}
                             [:div
                              {:style {:display      "inline-block"
                                       :margin-right ".5rem"}}
                              [badge/badge
                               {:variant :light
                                :pill?   true}
                               (->> contributor-options
                                    (cu/filter-by first aid)
                                    (first)
                                    (last))]]))
                      (doall))]
                [:td td-props
                 (loc/tr (:lp-report-holding/text-status holding-report))]
                [:td td-props
                 [:div
                  {:style {:display      "inline-block"
                           :margin-right ".5rem"}}
                  [badge/badge
                   {:variant :light
                    :pill?   true}
                   (->> approver-options
                        (cu/filter-by first text-approver)
                        (first)
                        (last))]]]
                [:td td-props
                 (if (or approve-access?
                         (and (or (lp-report-holding/can-edit-text? holding-ctx)
                                  (lp-report-holding/can-edit-chart? holding-ctx)
                                  (lp-report-holding/can-select-data-set? holding-ctx))
                              (not= :lp-report-holding.publishing-status/approved
                                    (:lp-report-holding/text-status holding-report))))
                   [:span
                    {:class (h/<class common-style/table-cursor-pointer)}
                    [:i.fal.fa-edit
                     {:style    {:font-size "1.25rem"}
                      :on-click #(rf/dispatch [::event/edit-holding-report holding-report])}]]
                   [:span
                    {:class (h/<class common-style/table-cursor-pointer)}
                    [:i.fal.fa-eye
                     {:on-click #(rf/dispatch [::event/view-holding-report holding-report])}]]
                 )]
                [:td td-props
                 (->> data-contributors
                      (map (fn [aid]
                             ^{:key (str "report-editor-" id "-contributor-" aid)}
                             [:div
                              {:style {:display      "inline-block"
                                       :margin-right ".5rem"}}
                              [badge/badge
                               {:variant :light
                                :pill?   true}
                               (->> contributor-options
                                    (cu/filter-by first aid)
                                    (first)
                                    (last))]]))
                      (doall))]
                [:td td-props
                 (loc/tr (:lp-report-holding/data-status holding-report))]
                [:td td-props
                 [:div
                  {:style {:display      "inline-block"
                           :margin-right ".5rem"}}
                  [badge/badge
                   {:variant :light
                    :pill?   true}
                   (->> approver-options
                        (cu/filter-by first data-approver)
                        (first)
                        (last))]]]
                [:td td-props
                 [:div
                  {:style {:display         "flex"
                           :flex-direction  "row"
                           :justify-content "flex-end"}}
                  [:div
                   (when-let [report-file (get attachments
                                               (:lp-report-holding/report-data-file
                                                holding-report))]
                     [:span (:attachment/filename report-file)
                      [:br]
                      (fu/display-datetime-timestamp (:common/updated-on report-file))]
                   )]
                  (when-let [report-file (get attachments
                                              (:lp-report-holding/report-data-file holding-report))]
                    [:div
                     {:style {:padding-left "8px"
                              :flex         "0 0 auto"
                              :align-items  "center"
                              :display      "inline-flex"
                              :font-weight  "bold"}}
                     [:span
                      {:class (h/<class common-style/table-cursor-pointer)}
                      [:i.fal.fa-download
                       {:style    {:font-size "1.25rem"}
                        :on-click (fn [e]
                                    (fu/prevent-default-event! e)
                                    (rf/dispatch [::event/download-data-file (:db/id report)
                                                  (:db/id report-file)]))}]]])
                  (when (and (lp-report-holding/can-update-data? holding-ctx)
                             (not= (:lp-report-holding/data-status holding-report)
                                   :lp-report-holding.publishing-status/approved))
                    [:div
                     {:style {:padding-left "8px"
                              :flex         "0 0 auto"
                              :align-items  "center"
                              :display      "inline-flex"
                              :font-weight  "bold"}}
                     [:span
                      {:class (h/<class common-style/table-cursor-pointer)}
                      [:i.fal.fa-save
                       {:style    {:font-size "1.25rem"}
                        :on-click (fn [e]
                                    (fu/prevent-default-event! e)
                                    (fu/trigger-click input-id))}]]])]]]))))
        (doall))]]]))


(defn view
  [report holdings input-id]
  [:div
   {:style {:margin "1rem 0"}
    :class (h/<class style/table-background)}
   [holding-reports-table report holdings input-id]])
